<template>
	<div>
		<PersonalBanner />
		<div class="content-zsy">
			<div class="title-wrap">
				<h3>팀머니</h3>
				<h4>팀머니 혜택 및 안내</h4>
			</div>
			
			<div class="about mb50">
				<div class="title mb20">팀머니란?</div>
				<p>
					일정금액을 충전하신 후 배송비 결제 시<br>
					간단하게 이용하실 수 있는 <strong>예치금 형태의 서비스</strong>입니다.<br>
					충전금액의 1%의 보너스 머니를 추가적립하여 드립니다.
				</p>
			</div>
						
			<div class="charge">
				<div class="content">
					<h5>
						충전금액의
						1% 추가적립
					</h5>
					
					<div class="pay_btn">충전하기</div>
				</div>
			</div>
			
			<div class="unit">
				<h6>팀머니 이용규정</h6>
				<ul class="check-list">
					<li>팀머니는 국제 배송비 결제 시 사용가능합니다.</li>
					<li>팀머니는 고로켓고의 서비스 내에서만 사용할 수 있는 전자화폐이며, 계정 소멸 전까지 보관됩니다.</li>
					<li>팀머니는 회원의 각종 할인혜택과 함께 제한없이 사용하실 수 있습니다.</li>
					<li>충전된 팀머니는 마이페이지 내의 나의 팀머니 내역에서 확인하실 수 있습니다.</li>
					<li>팀머니는 가상계좌 결제로 구매가능하시며 신용카드 결제 시 3%로의 카드 수수료가 발생합니다.</li>
					<li>충전된 팀머니 환불 요청 시 가상계좌로 결제하셨을 경우 3영업일 이내 잔액의 3% 수수료를 공제 후 환불하여 드립니다.</li>
					<li>충전된 팀머니 환불요청시 해당 팀머니의 구매로 인하여 적립지급된 보너스머니는 전량회수되며 이미 사용하셨을 경우에는 환불금에서 공제합니다.</li>
					<li>충전된 팀머니는 충전된 계정 내에서만 사용가능합니다.</li>
					<li>충전하신 팀머니는 충전한 계정 내에서만 사용가능하며 타 계정으로 이전이 불가능합니다.</li>
				</ul>
				
			</div>
			
		
		</div>
		
	</div>
</template>

<script>
	import PersonalBanner from '../../components/PersonalBanner.vue'
	export default {
		components: {
			PersonalBanner
		},
		data() {
			return{

			}
		},
		methods: {
		
		}
		
	}
</script>

<style scoped>
	.title-wrap{
		text-align: center;
		color: var(--frontground-color);
		margin-bottom: 60px;
	}
	.title-wrap h3 {
	    font-size: 20px;
	    font-weight: bold;
	    color: var(--frontground-color);
	    margin: 0 0 19px;
	}
	.title-wrap h4 {
	    font-weight: 700;
	    font-size: 36px;
	    line-height: 1.34;
	    margin: 0;
	}
	.about {
	    text-align: center;
	}
	.about .title {
	    font-weight: 700;
	    font-size: 24px;
	    line-height: 29px;
	    color: var(--frontground-color);
	}
	.charge {
	    border: 1px solid #DEDEDE;
	    border-radius: 30px;
		display: flex;
		justify-content: center;
		padding: 30px 0;
		margin: 0 auto;
		width: 500px;
	}
	.charge .content h5 {
	    font-weight: 700;
	    font-size: 24px;
	    line-height: 150%;
	    color: var(--secondary-color);
	    margin: 0 0 20px;
	}
	.pay_btn{
		width: 160px;
		line-height: 55px;
		background: #F00000;
		border-radius: 50px;
		text-align: center;
		font-weight: 800;
		font-size: 20px;
		color: #fff;
		margin: 0 auto;
		padding: 0 auto;
	}
	.unit{
		width: 768px;
		margin:0 auto 30px;
	}
	.unit h6 {
	    font-weight: 700;
	    font-size: 20px;
	    line-height: 24px;
	    color: #111111;
	    margin: 0 0 20px;
		margin-top: 50px;
	}
	ul.check-list {
	    margin: 0;
	    padding: 0;
	    list-style: none;
	}
	ul.check-list li {
	    padding-left: 26px;
	    background: url('../../assets/ico_check_grey.svg') no-repeat left 2px top 4px;
	    font-weight: 400;
	    font-size: 15px;
	    line-height: 23px;
	}
	
	
	.mb20 {
	    margin-bottom: 20px !important;
	}
	.mb50 {
	    margin-bottom: 50px !important;
	}
	@media (min-width: 992px) {
		.content-zsy{
			width: 1270px;
			margin: 2.5rem auto;
		}
	}
	@media (max-width: 768px) {	
		.title-wrap{
			margin-top: 20px;
		}
		.title-wrap h3 {
			font-size: 18px;
			color: #0055D4;
			font-weight: bold;
			line-height: 23px;
		}
		.title-wrap h4 {
			font-weight: 700;
			font-size: 30px;
			line-height: 39px;
			text-align: center;
		}
		.charge {
		    border: 1px solid #DEDEDE;
		    border-radius: 30px;
			display: flex;
			justify-content: center;
			padding: 30px 0;
			margin: 0 auto;
			width: 90%;
		}
		.unit{
			width: 90%;
		}
		
		.hidden-xs {
			display: none !important;
		}
	}
</style>